module.exports = __webpack_public_path__ + "static/img/p5.42f5d37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/p5.png
// module id = VSc2
// module chunks = 0